import React from 'react';
import Portfolio from './page/portfolio';

function App() {
    return <Portfolio />;
}

export default App;